import { render, staticRenderFns } from "./VendorInvoices.vue?vue&type=template&id=70c3d1c8&scoped=true&"
import script from "./VendorInvoices.vue?vue&type=script&lang=js&"
export * from "./VendorInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3d1c8",
  null
  
)

export default component.exports